import axios, { AxiosRequestConfig } from "axios";
import {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/CashManagementProvider";
import { UUID } from "../utils";
import getErrorDetails from "./helpers/getErrorDetails";
import {
  getPaginationInfoFromHeaders,
  PaginatedList,
} from "./helpers/pagination";

export const PROVIDER_IFX_PAYMENTS = "IFX Payments";

export type GetCashManagementsProviders = (
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProvider>>;

export type GetCashManagementProvider = (
  id: UUID,
  options?: AxiosRequestConfig
) => Promise<CashManagementProvider>;

export type GetSupportedCurrencies = (
  options?: AxiosRequestConfig
) => Promise<CashManagementProviderCurrencies>;

export type GetCashManagementConfigurableProviders = (
  options?: AxiosRequestConfig
) => Promise<PaginatedList<CashManagementProvider>>;

export const getCashManagementProviders: GetCashManagementsProviders = async (
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/cash-management/providers`,
    });
    const { data = {}, headers: responseHeaders = {} } = response;

    const {
      totalItems,
      currentPage,
      currentLimit,
    } = getPaginationInfoFromHeaders(responseHeaders);

    return {
      list: data || [],
      totalItems: totalItems,
      currentPage,
      currentLimit,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const getSupportedCurrencies: GetSupportedCurrencies = async (
  options
) => {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/cash-management/currencies`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
};
// TODO refactor after endpoint created
// Just mocked because currently there is only one provider that need config and there is not any endpoint to retrieve that
export const getCashManagementConfigurableProviders: GetCashManagementConfigurableProviders = async (
  options
) => {
  try {
    let providers = await getCashManagementProviders(options);
    return {
      ...providers,
      list: providers.list.filter(
        (provider) => provider.name === PROVIDER_IFX_PAYMENTS
      ),
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
};
